import './search-banner.scss';
import AOS from 'aos';

export default () => {
	AOS.init( {
		duration: 800,
		once: true,
	} );
	$( '#searchsubmit' ).click( function () {
		let inputPostcode = $( '#postcodeEntered' ).val();
		let inputHouseNumber = $( '#housenumberEntered' ).val();

		let regexPostcode = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
		let regexHousenumber = /^[1-9][0-9]{0,4}[a-zA-Z]{0,3}$/i;

		if ( regexPostcode.test( inputPostcode ) ) {
			if ( regexHousenumber.test( inputHouseNumber ) ) {
				$( '#loadingAnimation' ).removeClass( 'hidden' );
				$( '#searchForm' ).addClass( 'hidden' );
				testErasingEffect();
				setTimeout( type, 850, 'Bezig met zoeken...' );
				let request = jQuery.ajax( {
					url: '/wp-content/themes/thuisvaccinatie/app/Ajaxscripts/retrieveAvailability.php',
					type: 'POST',
					data: {
						inputPostcode: inputPostcode,
						inputHouseNumber: inputHouseNumber,
					},
				} );

				request.done( function ( msg ) {
					$( '#loadingAnimation' ).addClass( 'hidden' );
					let data = JSON.parse( msg );

					if ( data.error != undefined ) {
						$( '#alertDesc' ).text( 'Huisnummer en postcode komen niet overeen' );
						setTimeout( type, 950, 'Zoek op locatie' );
						launchToast();
						setTimeout( function () {
							$( '#searchForm' ).removeClass( 'hidden' );
						}, 1100 );
					} else if ( data.result.available_timewindows == undefined ) {
						$( '#alertDesc' ).text( 'Er zijn geen beschikbare datums gevonden' );
						setTimeout( type, 950, 'Zoek op locatie' );
						launchToast();
						setTimeout( function () {
							$( '#searchForm' ).removeClass( 'hidden' );
						}, 1100 );
					} else {
						testErasingEffect();
						setTimeout( type, 1100, 'Zoek op locatie:' );
						setTimeout( function () {
							$( '#searchForm' ).removeClass( 'hidden' );
						}, 1250 );
						$( '#vaccinateSection' ).html( '' );
						let appendHTML = '<h2 id=\'successFind\' style=\'margin-bottom: 40px;\'>Super!<br>Thuisvaccinatie vaccineert bij je thuis!</strong></h2>';
						let availableData = data.result.available_timewindows;
						let index = 1;

						if ( availableData != undefined ) {
							availableData.forEach( ( element ) => {
								let options = {
									weekday: 'long',
									year: 'numeric',
									month: 'long',
									day: 'numeric',
								};
								let dateFrom = new Date( element.date_time_from );
								let dateTo = new Date( element.date_time_to );
								let date = dateFrom.toLocaleDateString( 'nl-NL', options );
								let hoursFrom = dateFrom.getHours();

								if ( hoursFrom < 10 ) {
									hoursFrom = `0${hoursFrom}`;
								}
								let minutesFrom = dateFrom.getMinutes();

								if ( minutesFrom < 10 ) {
									minutesFrom = `0${minutesFrom}`;
								}

								let timeFrom = `${hoursFrom}:${minutesFrom}`;
								let hoursTo = dateTo.getHours();

								if ( hoursTo < 10 ) {
									hoursTo = `0${hoursTo}`;
								}
								let minutesTo = dateTo.getMinutes();

								if ( minutesTo < 10 ) {
									minutesTo = `0${minutesTo}`;
								}
								let timeTo = `${hoursTo}:${minutesTo}`;

								appendHTML +=
                  `${'<div class=\'containerDate\'>' +
                    '<div class=\'containerDate__left\'>' +
                    '<strong class=\'containerDate__left_IconNumber\'> '
                  }${index} </strong>` +
                  '<svg class=\'containerDate__left_Icon\' xmlns=\'http://www.w3.org/2000/svg\' width=\'50\' height=\'50\' viewBox=\'0 0 50 50\'>' +
                  '<defs>' +
                  '<style> .cls-1 {fill: #79af56; fill-rule: evenodd;}</style>' +
                  '</defs>' +
                  '<path id=\'icon\' class=\'cls-1\' d=\'M783.043,1079.37a1.95,1.95,0,0,0,1.953-1.95v-20.7a7.817,7.817,0,0,0-7.811-7.81h-2.539v-1.95a1.953,1.953,0,1,0-3.906,0v1.95h-8.885v-1.95a1.953,1.953,0,1,0-3.9,0v1.95h-8.788v-1.95a1.953,1.953,0,1,0-3.906,0v1.95h-2.441a7.817,7.817,0,0,0-7.811,7.81v30.46a7.826,7.826,0,0,0,7.811,7.82h34.37a7.826,7.826,0,0,0,7.811-7.82,1.953,1.953,0,0,0-3.906,0,3.909,3.909,0,0,1-3.905,3.91h-34.37a3.909,3.909,0,0,1-3.905-3.91v-30.46a3.907,3.907,0,0,1,3.905-3.9h2.441v1.95a1.953,1.953,0,0,0,3.906,0v-1.95h8.788v1.95a1.953,1.953,0,0,0,3.9,0v-1.95h8.885v1.95a1.953,1.953,0,0,0,3.906,0v-1.95h2.539a3.907,3.907,0,0,1,3.905,3.9v20.7A1.949,1.949,0,0,0,783.043,1079.37Z\' transform=\'translate(-735 -1045)\'/>' +
                  '</svg>' +
                  '</div>' +
                  '<div class=\'containerDate__right\'>' +
                  `<p class='containerDate__right_text'> ${date} </br> Tussen ${timeFrom} - ${timeTo} uur</p>` +
                  '</div>' +
                  '</div>';

								index++;
							} );
						}
						appendHTML +=
              '<a href=\'https://thuisvaccinatie.nl/afspraak-maken/\' class=\'button\' target=\'_blank\'>Afspraak maken </a>';
						$( '#vaccinateSection' ).append( appendHTML );
						let toScrollTo = document.querySelector( '#vaccinateSection' );

						toScrollTo.scrollIntoView( {
							behavior: 'smooth',
							block: 'start',
						} );
					}
				} );
			} else {
				$( '#alertDesc' ).text( 'Huisnummer is niet correct' );
				launchToast();
			}
		} else {
			$( '#alertDesc' ).text( 'Postcode is niet correct' );
			launchToast();
		}
	} );
};

let captionLength = 0;
let caption = '';

function launchToast () {
	// Successtoast for adding or removing destination
	let x = document.getElementById( 'toastAlert' );

	x.className = 'show';
	setTimeout( function () {
		x.className = x.className.replace( 'show', '' );
	}, 5000 );
}

function type ( passedString ) {
	let captionEl = $( '#caption' );
	let string = passedString;

	captionEl.html( string.substr( 0, captionLength++ ) );
	if ( captionLength < string.length + 1 ) {
		setTimeout( type, 50, string );
	} else {
		captionLength = 0;
		caption = '';
	}
}

function testErasingEffect () {
	let captionEl = $( '#caption' );

	caption = captionEl.html();
	captionLength = caption.length;
	if ( captionLength > 0 ) {
		erase();
	} else {
		setTimeout( 'testErasingEffect()', 1000 );
	}
}

function erase () {
	let captionEl = $( '#caption' );

	captionEl.html( caption.substr( 0, captionLength-- ) );
	if ( captionLength >= 0 ) {
		setTimeout( erase, 50 );
	} else {
		captionLength = 0;
		caption = '';
	}
}
